import {Component} from "react";
import PropTypes from "prop-types";
import Get from "../../../../lib/model/service/resource/dto/Get";

class InputDownload extends Component {

  render() {
    let href;
    let {defaultValue = '', dtoProperties} = this.props;
    let valueArray = [];
    if (defaultValue) {
      valueArray = defaultValue.split(':');
    }
    let resourceName = '';
    let resourceId = '';
    if (valueArray.length === 2) {
      resourceName = valueArray[1];
      resourceId = valueArray[0];
      href = Get.buildResourceLink(resourceId, resourceName, dtoProperties);
    }

    return <a
      href={href}
      className='text-cn-color-primary'>
      {resourceName}
    </a>
  }
}

InputDownload.propTypes = {
  defaultValue: PropTypes.string, onClick: PropTypes.func, dtoProperties: PropTypes.object
}
export default InputDownload;